import { useStore } from "@/stores";

/**
 * Hook to access snackbar functionality from UiStore.
 * Returns stable function reference (no .bind() to avoid new function on each render).
 */
export function useSnackbar() {
  const { uiStore } = useStore();

  // Return store method directly - MobX makeAutoObservable auto-binds methods
  return {
    showSnackbar: uiStore.showSnackbar,
  };
}
